export class ExperienceAudio {
  constructor(status) {
    this.status = status;
    this.context = null;
    this.analyser = null;
    this.frequency = null;
    this.element = new Audio();
    this.element.preload = 'auto';
    this.element.crossOrigin = 'anonymous';
    this.source = null;
    this.voiceEnabled = true;
    this.element.addEventListener('playing', () => this.status('NATURAL VOICE'));
    this.element.addEventListener('ended', () => this.status('VOICE READY'));
    this.element.addEventListener('error', () => this.status('AUDIO UNAVAILABLE'));
  }

  async unlock() {
    if (!this.context) {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!AudioContext) return false;
      this.context = new AudioContext();
      this.analyser = this.context.createAnalyser();
      this.analyser.fftSize = 256;
      this.frequency = new Uint8Array(this.analyser.frequencyBinCount);
      this.source = this.context.createMediaElementSource(this.element);
      this.source.connect(this.analyser).connect(this.context.destination);
    }
    if (this.context.state === 'suspended') await this.context.resume();
    return true;
  }

  stop() {
    this.element.pause();
    this.element.removeAttribute('src');
    this.element.load();
  }

  setEnabled(enabled) {
    this.voiceEnabled = Boolean(enabled);
    if (!this.voiceEnabled) this.stop();
  }

  // Start fetching a line before it is needed (live turns: the next speaker's line loads while the first one plays).
  preload(url) {
    if (!url) return;
    const absolute = new URL(url, location.href).href;
    if (this.element.src === absolute) return;
    this.element.src = url;
    this.element.load();
  }

  async play(url) {
    if (!this.voiceEnabled || !url) return false;
    await this.unlock();
    const absolute = new URL(url, location.href).href;
    if (this.element.src !== absolute) this.element.src = url;
    this.element.currentTime = 0;
    try {
      await this.element.play();
      return true;
    } catch {
      this.status('TAP AUDIO TO PLAY');
      return false;
    }
  }

  mouthLevel() {
    if (!this.analyser || this.element.paused) return 0;
    this.analyser.getByteFrequencyData(this.frequency);
    let total = 0;
    const count = Math.min(24, this.frequency.length);
    for (let index = 2; index < count; index += 1) total += this.frequency[index];
    return Math.min(1, total / Math.max(1, (count - 2) * 92));
  }
}
